import { __awaiter, __generator } from "tslib";
import { DataSyncModeEnum, FbClientBuilder, UserBuilder } from '@featbit/js-client-sdk';
import { Fetch } from '@ekuaibao/fetch';
import { uuid } from '@ekuaibao/helpers';
var fbClient;
var cacheKey = 'HOSE_FB_ANONYMOUS_ID';
var SDK_STORAGE_KEY = 'fb-datastore';
function getAnonymousId() {
    var cacheId = localStorage.getItem(cacheKey);
    if (!cacheId) {
        cacheId = uuid();
        localStorage.setItem(cacheKey, cacheId);
    }
    return cacheId;
}
var featBitConfig = function () {
    var clientKey = window.getEnvConfigValue('featBitClientKey', 'uXS-G58nrU-NZeY1rC7NIA6SLgEkNFGUW3G6zT4tMTcQ');
    var featBitDomain = window.getEnvConfigValue('featBitDomain', 'https://feat.hosecloud.com');
    return {
        clientKey: clientKey,
        eventUrl: featBitDomain,
        openapiUrl: featBitDomain
    };
};
export var initFeatBit = function (user) { return __awaiter(void 0, void 0, void 0, function () {
    var staffId, ekbCorpId, hasCache, config, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                if (!user) {
                    staffId = Fetch.staffId;
                    ekbCorpId = Fetch.ekbCorpId;
                    if (!ekbCorpId) {
                        return [2];
                    }
                    user = new UserBuilder(staffId).name(staffId).custom('corpId', ekbCorpId).build();
                }
                hasCache = !!localStorage.getItem(SDK_STORAGE_KEY + "-" + user.keyId);
                config = featBitConfig();
                fbClient = new FbClientBuilder()
                    .sdkKey(config.clientKey)
                    .pollingUri(config.eventUrl)
                    .eventsUri(config.openapiUrl)
                    .dataSyncMode(DataSyncModeEnum.POLLING)
                    .pollingInterval(60000)
                    .user(user)
                    .build()
                    .addListener('error', function (error) {
                    console.log(error);
                });
                if (!!hasCache) return [3, 2];
                console.log('FeatBit: No cache found, waiting for network initialization...');
                return [4, fbClient.waitForInitialization()];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                console.log('FeatBit: Fast start with local cache');
                _a.label = 3;
            case 3: return [3, 5];
            case 4:
                e_1 = _a.sent();
                console.log(e_1);
                return [3, 5];
            case 5: return [2];
        }
    });
}); };
export function switchFeatBitUser() {
    var user = createFBUser(Fetch.staffId, Fetch.staffId, [
        { name: 'staffId', value: Fetch.staffId },
        { name: 'corpId', value: Fetch.ekbCorpId }
    ]);
    var hasCache = !!localStorage.getItem(SDK_STORAGE_KEY + "-" + user.keyId);
    var identifyPromise = fbClient === null || fbClient === void 0 ? void 0 : fbClient.identify(user);
    if (hasCache) {
        console.log('FeatBit: Identity switch using cache, syncing in background...');
        return Promise.resolve();
    }
    return identifyPromise;
}
export var anonymousUser = function () {
    var anonymousId = getAnonymousId();
    return createFBUser(anonymousId, anonymousId);
};
var createFBUser = function (keyId, name, customizedProperties) {
    if (customizedProperties === void 0) { customizedProperties = []; }
    var anonymousId = getAnonymousId();
    var properties = customizedProperties.concat([
        { name: 'anonymousId', value: anonymousId },
        { name: 'clientCategory', value: 'web' },
        { name: 'domain', value: location.host },
        { name: 'pathname', value: location.pathname }
    ]);
    var user = new UserBuilder(keyId).name(name);
    properties.forEach(function (_a) {
        var name = _a.name, value = _a.value;
        user.custom(name, value);
    });
    return user.build();
};
export var getVariation = function (flagKey, defaultValue) {
    return (fbClient === null || fbClient === void 0 ? void 0 : fbClient.variation(flagKey, defaultValue)) || defaultValue;
};
export var getBoolVariation = function (flagKey, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    return (fbClient === null || fbClient === void 0 ? void 0 : fbClient.boolVariation(flagKey, defaultValue)) || defaultValue;
};
